import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { Furniture } from "../models";
import { mapGetToPostParams } from "../../app/helpers";

/**
 * @class FurniturePmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Furniture>}
 */
export class FurniturePmsApiService extends AbstractDownloadableService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/furniture(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {Furniture}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Furniture(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Furniture>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Furniture} furniture
     * @param {Property} property
     * @returns {Promise.<Furniture>}
     */
    create(furniture, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, furniture.toObjectExcept('property', 'supplier'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Integer} propertyId
     * @param {Integer} furnitureId
     * @param {Object} params
     */
    show(propertyId, furnitureId, params = {}) {
        
        const url = this.url({
            propertyId: propertyId,
            id: furnitureId
        });

      return this.http
                 .get(url, {
                     headers: this.authHeaders,
                     params
                 })
                 .then(this.getModeler())
                 .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Furniture} furniture
     * @returns {Promise.<Furniture>}
     */
    update(furniture) {
        
        const url = this.url({
            propertyId: furniture.property.id,
            id:         furniture.id
        });
        
        return this.http
                   .put(url, furniture.toObjectExcept('property', 'supplier'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Furniture} furniture
     * @returns {Promise.<boolean>}
     */
    delete(furniture) {
        
        const url = this.url({
            propertyId: furniture.property.id,
            id:         furniture.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     */
    exportToExcel(params = {}, property = null) {
        
        const url = this.url({
            propertyId: property ? property.id : 0
        });

        return this.download(url + '/export-to-excel', mapGetToPostParams(params), 'Furniture.xls');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/furniture.service.js